var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradiIcone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.64 23.52",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-4{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#4d69fa;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-1,.cls-3,.cls-4{stroke-width:0.75px;}.cls-3{fill:#fff;}.cls-4{stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tradi-icone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.25 0.53 0.85 0.51 0.85 2.55 21.25 2.57 21.25 0.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 2.54,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 4.59,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 6.63,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 8.67,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.4,12.49H18.6a0,0,0,0,1,0,0V16.3a1,1,0,0,1-1,1H14.4a1,1,0,0,1-1-1V12.49A0,0,0,0,1,13.4,12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.4,12.75H8.6a0,0,0,0,1,0,0V16.3a1,1,0,0,1-1,1H4.4a1,1,0,0,1-1-1V12.75A0,0,0,0,1,3.4,12.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11,
    y: 12.49,
    width: 10.19,
    height: 7.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.83,
    y: 12.49,
    width: 10.17,
    height: 7.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 19.49,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.84,
    y: 15.15,
    width: 5.43,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 22.55,
    y1: 18,
    x2: 21.55,
    y2: 16.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.55,
    y1: 18,
    x2: 21.55,
    y2: 16.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 22.55,
    y1: 19.99,
    x2: 21.55,
    y2: 21.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.55,
    y1: 19.99,
    x2: 21.55,
    y2: 21.06
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradiIcone);
export default __webpack_public_path__ + "static/media/tradi-icone.061f6b5cdb2fb955719da2e485285abc.svg";
export { ForwardRef as ReactComponent };